import React from 'react';
import Text from '@ingka/text';

export const Introduction: React.FC = () => {
  return (
    <div className="introduction">
      <Text tagName="h3" textStyle="Heading.S">Welcome to the Market Campaign Tool a platform to access customer diagnostics</Text>
      <br />
      <br/>
      <Text tagName="p" textStyle="Statement.M">This tool provides access to predicted analytic scores of IKEA customers.
        Scores are calculated via a machine learning algorithm based on features from customer interaction data. Approximately 30 to 50 separate 
        features are used to create the scores and identify customers most likely to respond to a campaign offer. 
        <br />
        <br />
        Click on one of the buttons to access specific scores.
        <br />
        <br />
      </Text>
    </div>
  );
}